import { render, staticRenderFns } from "./looking-for-groups-indicator.vue?vue&type=template&id=10c9bcf7&scoped=true&lang=pug&"
import script from "./looking-for-groups-indicator.vue?vue&type=script&lang=js&"
export * from "./looking-for-groups-indicator.vue?vue&type=script&lang=js&"
import style0 from "./looking-for-groups-indicator.vue?vue&type=style&index=0&id=10c9bcf7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c9bcf7",
  null
  
)

export default component.exports